import { PreviousEventState } from '@/store/previous-event/types';

export const initialPreviousEventState: PreviousEventState = {
  selectCompany: '',
  selectedSla: '',
  selectedCategory: '',
  nameEvent: '',
  currentPage: 1,
};
